import SimpleTax from "assets/images/new_logo.png";

export const Simpletax = {
  logo: SimpleTax,
  width: "150px",
};
